import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row g-4" }
const _hoisted_2 = { class: "col-12 col-xl-6" }
const _hoisted_3 = { class: "col-12 col-xl-6" }
const _hoisted_4 = { class: "col-12 col-xl-6" }
const _hoisted_5 = { class: "col-12 col-xl-6" }

import {
  computed, onBeforeMount,
  reactive,
  watch,
} from 'vue';
import CityInterface from '@/interfaces/CityInterface';
import StreetInterface from '@/interfaces/StreetInterface';

import {
  enet as EnetApi,
} from '@/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddressGroup',
  props: {
  postcode: {},
  city: {},
  street: {},
  houseNumber: {},
  errors: {
    type: Object,
    default: () => ({}),
  },
  disabled: Boolean,
},
  emits: [
  'update:postcode',
  'update:city',
  'update:street',
  'update:houseNumber',
],
  setup(__props, { emit }) {

const props = __props





const addressData = reactive({
  postcode: null as string | null,
  isLoading: false,
  isImmediateFetch: false,
  cities: [] as CityInterface[],
  streets: [] as StreetInterface[],
});

const cityOptions = computed(() => addressData.cities.map((city: CityInterface) => ({
  value: city.id,
  label: city.name,
})));

const streetOptions = computed(() => addressData.streets.map((street: StreetInterface) => ({
  value: street.id,
  label: street.name,
})));

const fetchCitiesAndStreets = (postcode) => {
  const validatedPostcode = `${postcode || ''}`.trim();

  if (validatedPostcode.length === 5 && validatedPostcode !== addressData.postcode) {
    addressData.cities = [];
    addressData.streets = [];

    addressData.isLoading = true;

    EnetApi.getCitiesAndStreets(validatedPostcode)
      .then((data) => {
        addressData.cities = data.cities;
        addressData.streets = data.streets;

        if (!addressData.isImmediateFetch) {
          emit('update:city', addressData.cities[0].id);
          emit('update:street', addressData.streets[0].id);
          addressData.isImmediateFetch = false;
        }
      }).catch(() => {
        emit('update:city', null);
        emit('update:street', null);
      }).finally(() => {
        addressData.postcode = validatedPostcode;
        addressData.isLoading = false;
      });
  }
};

onBeforeMount(() => {
  addressData.isImmediateFetch = `${props.postcode || ''}`.trim().length === 5;
});

watch(() => props.postcode, ($newPostcode) => {
  fetchCitiesAndStreets($newPostcode as string);
}, {
  immediate: true,
});

return (_ctx: any,_cache: any) => {
  const _component_InputField = _resolveComponent("InputField")!
  const _component_SelectField = _resolveComponent("SelectField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InputField, {
        label: "Postleitzahl*",
        "only-numeric": true,
        "error-numeric": "Ungültige Postleitzahl",
        "max-length": 5,
        "min-length": 5,
        "model-value": __props.postcode,
        error: __props.errors['postcode'],
        onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:postcode', $event))),
        required: "",
        disabled: __props.disabled,
        "read-only": __props.disabled,
        "show-loader": addressData.isLoading
      }, null, 8, ["model-value", "error", "disabled", "read-only", "show-loader"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(cityOptions).length <= 1)
        ? (_openBlock(), _createBlock(_component_InputField, {
            key: 0,
            label: "Ort*",
            type: "text",
            disabled: __props.disabled || _unref(cityOptions).length === 0,
            readonly: _unref(cityOptions).length === 1,
            "model-value": __props.city,
            error: __props.errors['city'],
            onInput: _cache[1] || (_cache[1] = ($event: any) => (emit('update:city', $event))),
            required: ""
          }, null, 8, ["disabled", "readonly", "model-value", "error"]))
        : (_openBlock(), _createBlock(_component_SelectField, {
            key: 1,
            label: "Ort*",
            options: _unref(cityOptions),
            disabled: __props.disabled || _unref(cityOptions).length === 0,
            search: _unref(cityOptions).length > 10,
            "model-value": __props.city,
            error: __props.errors['city'],
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (emit('update:city', $event)))
          }, null, 8, ["options", "disabled", "search", "model-value", "error"]))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SelectField, {
        label: "Straße*",
        options: _unref(streetOptions),
        disabled: __props.disabled || _unref(streetOptions).length === 0,
        search: _unref(streetOptions).length > 10,
        "model-value": __props.street,
        error: __props.errors['street'],
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (emit('update:street', $event)))
      }, null, 8, ["options", "disabled", "search", "model-value", "error"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_InputField, {
        label: "Hausnummer*",
        type: "text",
        "model-value": __props.houseNumber,
        error: __props.errors['houseNumber'],
        onInput: _cache[4] || (_cache[4] = ($event: any) => (emit('update:houseNumber', $event))),
        required: "",
        disabled: __props.disabled
      }, null, 8, ["model-value", "error", "disabled"])
    ])
  ]))
}
}

})